import React  from 'react';
import './App.css';
import { useNavigate } from "react-router-dom";

class DocumentListToolbar extends React.Component {

	constructor(props) {

		super(props);
		
		this.handleSelectLink = this.handleSelectLink.bind(this);
		this.renderLink = this.renderLink.bind(this);
	}
	
	handleSelectLink(page) {		
		const navigate = this.props.navigate;
  		navigate(page);
	}
	
	renderLink(renderYN, linkTitle, linkValue) {
		
		if (!renderYN) {
			return;
		}

		var classNameString = "DocumentListToolbarLink";
		
		return (
			<div 
				className={classNameString}
				onClick={() => this.handleSelectLink(linkValue)}
			>
				{linkTitle}
			</div>
		);
	}
	
	render() {

		var modelName = this.props.modelName;		
		var newQuestionSampleString = "New document";
		
		return (
			<div className="DocumentListToolbarContainer1">
				<div className="DocumentListToolbarLeft">
					<div 
						className="DocumentListToolbarLink"
						onClick={() => this.handleSelectLink("/selectmodel")}
					>
						{modelName}
					</div>
				</div>
				<div className="DocumentListToolbarRight">
					<div className="DocumentListToolbarContainer2">
						{this.renderLink(true, newQuestionSampleString, "/docs/new")}
					</div>
				</div>
			</div>
		);
	}
}

export default function DocumentListToolbarFunction(props) {
	const navigate = useNavigate();
	return <DocumentListToolbar {...props} navigate={navigate} />;
}

